import { Box } from '@mui/material';
import loader from '../../images/Loader.gif';
import { LoaderStyles as classes } from './LoaderStyles';
import { LOADER_ALT_MSG } from '../../constants';

const Loader = () => (
  <div data-testid="loader_id">
    <Box component="img" src={loader} sx={classes.loader_circle} alt={LOADER_ALT_MSG} />
  </div>
);

export default Loader;
